import { Grid, Switch } from '@mui/material'
import SoftBox from 'components/SoftBox'
import React, { useEffect, useState } from 'react'
import { useAgencyInfo } from "context/agency";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CopyToClipboard from "react-copy-to-clipboard";
import env from "config/env";
import SoftTypography from 'components/SoftTypography';
import FormField from "layouts/pages/account/components/FormField";
import { useUploadImage } from "hook/services";
import Editor from "./components/QuillEditor"

function VideoContent({ handleImage, handleSubmit, loading }) {
  const customUrlDomain = env.ACCOUNT_LEVEL_URL
  const SERVER_IP = env.SERVER_IP;
  const [agency] = useAgencyInfo();
  const [domainupdate, setDomainupdate] = useState(false);
  const [DefaultImage, setDefaultImage] = useState(agency?.Customization?.default_image || true);
  const [custom_color, setcustom_color] = useState(agency?.Customization?.custom_color || false);
  const [copy, setcopy] = useState(false);
  const [default_image_switch, setdefault_image_switch] = useState(false);
  const [inputText, setInputText] = useState(agency?.Customization?.video_text || '')

  // State to hold CKEditor content
  const [editorContent, setEditorContent] = useState(agency?.Customization?.video_link || '');
  useEffect(() => { if (editorContent === '') setEditorContent(agency?.Customization?.video_link || ''); }, [agency?.Customization?.video_link])

  // Handle CKEditor change
  const handleEditorChange = (html) => {
    setEditorContent(html); // Update state with CKEditor content
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const formData = {
      video_text: inputText, // Get video_text value from the form
      video_link: editorContent, // Include CKEditor content
    };

    // Call the parent handleSubmit function and pass the form data
    handleSubmit(e, formData);
  };
  return (
    <div>
      <SoftBox component="form" onSubmit={handleFormSubmit}>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} style={{ paddingBottom: 0 }}>

          <Grid item xs={12} className="px-2">
            <FormField
              label="Video text"
              placeholder="Link text that will be visible"
              name="video_text"
              onChange={(e) => setInputText(e.target.value)}
              value={inputText}
            />
          </Grid>
          <Grid item xs={12} className="px-2 mb-4">
            {/* <CKEditor
              config={{
                mediaEmbed: { previewsInData: true },
                alignment: { options: ["left", "right"] },
                toolbar: [
                  "heading",
                  "|",
                  "bold",
                  "italic",
                  "underline",
                  "link",
                  "subscript",
                  "superscript",
                  "|",
                  "fontSize",
                  "fontFamily",
                  "|",
                  "bulletedList",
                  "numberedList",
                  "|",
                  "indent",
                  "outdent",
                  "|",
                  "imageUpload",
                  "mediaEmbed",
                  "|",
                  "insertTable",
                  "blockQuote",
                  "|",
                  "findAndReplace",
                  "pageBreak",
                  "|",
                  "sourceEditing",
                  "|",
                  "undo",
                  "redo",
                ],
                fontSize: {
                  options: [8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 24, 28, 32, 36],
                  supportAllValues: true,
                },
                link: { addTargetToExternalLinks: true },
              }}
              editor={ClassicEditor}
              onChange={(event, editor) => {
                setEditorContent(editor.getData()); // Update state with CKEditor content
              }}
              data={editorContent} // Set CKEditor content
            /> */}
            <div style={{ marginBottom: "30px", height: "200px" }}>
              <Editor value={editorContent} onChange={(e) => setEditorContent(e)} />
            </div>
          </Grid>

          <Grid item xs={12} className="px-2" display="flex" justifyContent={"flex-end"}>
            <SoftButton
              className="bg-dark"
              color="dark"
              type="submit"
              disabled={loading} // Disable button while loading
              style={{
                cursor: loading ? "not-allowed" : "pointer", // Change cursor to 'not-allowed' while loading
              }}
            >
              Update
            </SoftButton>
          </Grid>
        </Grid>
      </SoftBox>
    </div>
  )
}

export default VideoContent 
